import {
  HttpExclude,
  RequestExpose,
  Resource,
  ResourceCollection,
} from 'simpli-web-sdk'
import {ResponsavelGrupoParceiroCollection} from '@/model/collection/ResponsavelGrupoParceiroCollection'
import {IResponsavelGrupoParceiroResourcesHolder} from '@/interfaces/resource/IResponsavelGrupoParceiroResourcesHolder'
@HttpExclude()
export class ResponsavelGrupoParceiroFilterCollection extends ResponsavelGrupoParceiroCollection {
  constructor() {
    super()
  }
  resource?: IResponsavelGrupoParceiroResourcesHolder
  idList: ResourceCollection<Resource> | null = null

  @RequestExpose() id: number | string | null = null
  set idAsResource(input: Resource | null) {
    this.id = input?.$id || null
  }
  get idAsResource() {
    return this.idList?.getResource(this.id) || null
  }
}
